var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.profileImageUrl === undefined || _vm.profileImageUrl === null)?_c('v-icon',{attrs:{"size":_vm.size}},[_vm._v("mdi-account-circle")]):_c('v-img',{attrs:{"src":_vm.profileImageUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }